var React = require('react');

function IconWaitingCircleO (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M513.3 62.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z","key":0}),React.createElement("path",{"d":"M371.5 605.2c3.1-3.2 3.7-8 1.5-11.9-35.4-61.2-26.9-140.7 25.4-193.1 52.3-52.3 134.4-63.4 195.7-28.3 3.9 2.2 8.8 1.6 12-1.6l32.4-32.4c4.5-4.5 3.7-11.9-1.5-15.4-87.3-57.8-208.5-45.7-285.3 31.1-76.5 76.5-85.4 195.2-28.3 282.1 3.8 5.8 12.1 6.7 17 1.8l31.1-32.3zM652.7 415.7c-3.2 3.2-3.9 8.3-1.5 12.2 36.9 61.7 26.3 145.3-26.7 198.4-53.1 53.1-131.5 58.4-192.8 21.1-3.9-2.4-9-1.8-12.2 1.5l-31.8 31.8c-4.4 4.4-3.8 11.9 1.4 15.3 86.9 58 202.8 51.2 279.5-25.5s88.8-197.8 31.2-285.1c-3.5-5.3-10.9-6-15.4-1.5l-31.7 31.8z","key":1})]));
}

IconWaitingCircleO.displayName = "IconWaitingCircleO";

IconWaitingCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconWaitingCircleO;

IconWaitingCircleO.default = IconWaitingCircleO;
